import { render } from "./Categories.vue?vue&type=template&id=1735e692&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=1735e692&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1735e692"]])

export default __exports__